// @ts-strict-ignore
import { useCatalogSearch } from "@shared/hooks/useCatalogSearch/useCatalogSearch";

const useHasCatalogSearchShared = (includeQuery = true): boolean => {
  const {
    activeIngredients,
    excludedIngredients,
    activeBrands,
    activeSupplementTypes,
    activeConditions,
    activeCategories,
    activeTaxonomies,
    activeOptimizedTaxonomies,
    activeEqpLevels,
    activeFilters,
    searchQuery,
    isOnlyShowInStock,
    isOnlyShowEmersonNew,
    isOnlyShowFavorites,
    isFsTested,
  } = useCatalogSearch();

  return (
    (includeQuery ? !!searchQuery : false) ||
    activeBrands?.length > 0 ||
    activeIngredients?.length > 0 ||
    excludedIngredients?.length > 0 ||
    activeFilters?.length > 0 ||
    activeSupplementTypes?.length > 0 ||
    activeConditions?.length > 0 ||
    activeCategories?.length > 0 ||
    activeTaxonomies?.length > 0 ||
    activeOptimizedTaxonomies?.length > 0 ||
    activeEqpLevels?.length > 0 ||
    isOnlyShowInStock ||
    isOnlyShowEmersonNew ||
    isOnlyShowFavorites ||
    isFsTested
  );
};

export { useHasCatalogSearchShared };
